import { Button, Form, Input } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function Remarks({ onVerify, goBack }) {
  const [form] = Form.useForm();
  const [feedback, setFeedback] = useState("");
  const { t } = useTranslation();
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setFeedback(inputValue);
  };

  return (
    <Form layout="vertical" form={form} onFinish={onVerify}>
      <Form.Item
        label={t("pages.pending_approval.write_your_remarks", {
          defaultValue: "Write Your Remarks",
        })}
        name="authorizerComments"
        rules={[
          {
            required: true,
            message: t("errorMesssages.remark_require", {
              defaultValue: "Reason is required",
            }),
          },
        ]}
      >
        <Input.TextArea
          rows={5}
          placeholder={t("common.remarks", { defaultValue: "Reason" })}
          onChange={handleInputChange}
          showCount
          maxLength={250}
        />
      </Form.Item>

      <div className="d-flex justify-content-end  mt-3">
        <Button
          className="secondary-btn mx-4"
          type="default"
          onClick={() => goBack()}
        >
          {t("buttons.cancel_btn", {
            defaultValue: "Cancel",
          })}
        </Button>
        <Button type="primary" className="primary-btn" htmlType="submit">
          {t("buttons.submit_btn", {
            defaultValue: "Submit",
          })}
        </Button>
      </div>
    </Form>
  );
}
